var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.open
    ? _c(
        "app-open-by-month",
        {
          staticClass: "set-height",
          attrs: {
            "chart-data": _vm.open,
            "show-prev-year": false,
            height: 250,
            "chart-type": "area",
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(" " + _vm._s(_vm.$ct("cash-in-flow")) + " "),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }